import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Box, Avatar } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import useLogout from '../auth/logout'; 
import siteLogo from '../assets/images/devsight_logo_3.webp';
import { NavLink } from 'react-router-dom';
import { profileData } from '../data/data_profile';
import { PROFILE_UPDATED_EVENT } from '../utils/profile_events';

const Header = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const logout = useLogout(); 

  const isValidImageUrl = (url) => {
    if (!url) return false;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const fetchProfile = async () => {
    try {
      const profileResponse = await profileData.getProfile();
      setProfile(profileResponse);
    } catch (error) {
      console.error('Error loading profile:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();

    // Listen for profile updates
    const handleProfileUpdate = () => {
      fetchProfile();
    };

    window.addEventListener(PROFILE_UPDATED_EVENT, handleProfileUpdate);

    return () => {
      window.removeEventListener(PROFILE_UPDATED_EVENT, handleProfileUpdate);
    };
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
  };

  const getAvatarUrl = () => {
    if (profile?.image_url && isValidImageUrl(profile.image_url)) {
      return profile.image_url;
    }
    return undefined;
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Box display="flex" alignItems="center" flexGrow={1}>
          <img src={siteLogo} alt="DevSight Logo" style={{ height: '40px', marginRight: '10px' }} />
          <Typography variant="h6">
            DevSight
          </Typography>
        </Box>
        <div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            {!isLoading && getAvatarUrl() ? (
              <Avatar 
                src={getAvatarUrl()}
                sx={{ width: 32, height: 32 }}
                imgProps={{
                  onError: (e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.style.backgroundColor = 'inherit';
                  }
                }}
              >
                <AccountCircle />
              </Avatar>
            ) : (
              <AccountCircle />
            )}
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose} component={NavLink} to="/profile">Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

